export default __webpack_public_path__ + "images/8866dc92f0f97fac1eb95bccbc4f2598.svg";